import React, { FC } from 'react';
import { AVAILABLE_PERK_BACKGROUND, EMPTY_PERK_BACKGROUND } from 'hooks/context/Perks';
import { PunchProgressBar } from './PunchProgressBar';
import { LineProgressBar } from './LineProgressBar';
import { PerkType } from 'olo-service';

type PerkProgressProps = React.HTMLAttributes<HTMLElement> & {
  children?: never;
  perkType?: PerkType;
  earned?: number;
  required?: number;
  complete?: boolean
}

export const PerkProgress : FC<PerkProgressProps> = ({ className, perkType, earned, required, complete=false }) => {

  if (earned === undefined || required === undefined ) return null;

  // POINTS
  const perkPercentComplete = complete ? 100 : (earned * 100)/required;

  // PUNCHCARD
  const punchesEarnedStars = complete ? required : earned;
  const punchesEmptyStars = complete ? 0 : required - earned;

  return (
    <>
    {perkType === 'POINT' && <LineProgressBar className={className} percentComplete={perkPercentComplete} completeIconImage={AVAILABLE_PERK_BACKGROUND} />}
    {perkType === 'PUNCHCARD' &&
      <PunchProgressBar className={className} earnedStars={punchesEarnedStars} emptyStars={punchesEmptyStars} earnedStarImage={AVAILABLE_PERK_BACKGROUND} emptyStarImage={EMPTY_PERK_BACKGROUND} />}
    </>
  );

};
